





























































































































































































































import {
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Input from "@/shared/components/ui/Input.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import Widget from "@/shared/components/Widget.vue";
import DocumentSignature from "@/employee/components/DocumentSignature.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import { useNotifierStore } from "@/shared/store/notifier";
import { useImpersonatorStore } from "@/shared/store/impersonator";
import { useDeductibleTrackerStore } from "@/employee/store/deductibleTracker";
import { useClaimStore } from "@/employee/store/claim";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import HsabEnrollmentSettings
  from "@/employee/components/settings/hsaBank/HsabEnrollmentSettings.vue";

@Component({
  components: {
    HsabEnrollmentSettings,
    SettingsNavigation,
    SettingsHeader,
    Widget,
    Checkbox,
    Input,
    DocumentSignature,
    GenericLoadingSpinner
  }
})
export default class DeductibleTrackerSettings extends Vue {
  notifierStore = useNotifierStore();
  impersonatorStore = useImpersonatorStore();
  deductibleTrackerStore = useDeductibleTrackerStore();
  claimStore = useClaimStore();
  documentStore = useSigningDocumentStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();

  showIframe = false;
  isIframeRendered = false;
  termsAccepted = false;
  subscriberId = "";
  viewConnect = false;
  hphcOptOutForm = false;
  ViewClaimsRoute = RouteNames.ViewClaims;
  DocumentView = RouteNames.DocumentView;
  displayHphcSignup = false;

  mounted (): void {
    this.claimStore.loadUserHasThirdPartyClaims();
    this.deductibleTrackerStore.retrieveIframeUrl();
    this.deductibleTrackerStore.retrieveHealthPlanIsLinked();
    this.activateIframeRenderingDelay();
    this.userStore.loadPartnerSettings();
    this.claimStore.loadIsHPHCOptedIn();
    this.optInChange();
  }

  authorizeHphc () {
    this.claimStore.optInHPHC({ memberId: this.subscriberId, optIn: true })
      .then(_ => {
        if (!this.claimStore.hphcOptIn) {
          this.notifierStore.setDanger(
            "Please verify your Subscriber ID and try again.");
        }
      });
  }

  activateIframeRenderingDelay () {
    setTimeout(() => this.isIframeRendered = true, 4000);
  }

  get disableHphcAuthorize () {
    return !this.termsAccepted || this.subscriberId.length < 10;
  }

  get documentId () {
    return this.documentStore.currentDocument && this.documentStore.currentDocument.documentId
      ? this.documentStore.currentDocument.documentId : null;
  }

  @Watch("claimStore.hphcOptIn")
  optInChange () {
    if (!this.claimStore.hphcOptIn) {
      this.documentStore.getDocumentLatestVersion(this.documentId);
    }
  }

  setIframeVisible () {
    this.showIframe = true;
  }

  get showConnectSection () {
    if (!this.userStore.claimsOptIn) return true;

    if (this.claimStore.hphcOptIn) {
      if (this.deductibleTrackerStore.healthPlanIsLinked) return true;

      return this.viewConnect;
    }

    return false;
  }

  acceptHPHCTerms () {
    this.termsAccepted = !this.termsAccepted;
  }

  viewConnectSection () {
    this.viewConnect = true;
  }

  showCancelHpHc (value) {
    this.hphcOptOutForm = value;
  }

  hphcOptOut () {
    this.claimStore.optOutHPHC();
    this.hphcOptOutForm = false;
    this.subscriberId = "";
    this.documentStore.deleteSignature("HPHC-opt-in")
      .then(() => this.documentStore.getDocumentLatestVersion("HPHC-opt-in"))
      .then(() => this.displayHphcSignup = false);
  }

  showHphcSignup () {
    this.displayHphcSignup = true;
  }
}
